<template>
  <div>
    <vs-popup :title="$t('CreateNewCollection')" :active.sync="showModal">
      <form id="brand-form">
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="collectionName"
          :label="$t('Name')"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('collectionName')"
          >{{ errors.first("collectionName") }}</span
        >

        <label class="vs-select--label">{{ $t("Position") }}</label>
        <v-select
          label="name"
          class="mb-4"
          name="collectionPosition"
          :options="collectionPositions"
          v-model="model.position"
          v-validate="{ required: true }"
          :reduce="(x) => x.id"
          dir="rtl"
        >
        </v-select>
        <span
          class="text-danger text-sm"
          v-show="errors.has('collectionPosition')"
          >{{ errors.first("collectionPosition") }}</span
        >

        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.priority"
          :label="$t('Priority')"
          v-validate="{ regex: '^([0-9]+)$' }"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('collectionPriority')"
          >{{ errors.first("collectionPPriority") }}</span
        >

        <vs-checkbox v-model="model.isActive" :disabled="true">{{
          $t("Active")
        }}</vs-checkbox>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}

#brand-form .uploader-box > img {
  top: 0;
  -webkit-transform: unset;
  transform: unset;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    collectionName: {
      required: "لطفا نام مجموعه را وارد نمایید.",
    },
    collectionPosition: {
      required: "لطفا موقعیت را انتخاب نمایید.",
    },
    collectionPPriority: {
      regex: "تنها مجاز به وارد کردن مقادیر عددی می‌باشید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Content_management_ProductCollection_ModifyPopup",
  props: {
    show: { default: false },
  },
  data() {
    return {
      collectionPositions: [{ name: "صفحه نخست", id: 0 }],
      disabled: false,
      model: {
        name: "",
        priority: "",
        position: "",
        isActive: true,
      },
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createCollection: "productCollection/create",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          this.createCollection(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.model = {
          name: "",
          priority: "",
          position: "",
          isActive: true,
        };
      }
      this.$validator.reset();
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
